import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink, RouterLinkActive, RouterOutlet } from "@angular/router";
import { FormsModule } from '@angular/forms';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';

import { CompanyMaster } from '../../models/auth-response'; // Tu archivo centralizado de interfaces
import { SaasService } from '../../Service/saas-service'; // Crearemos este servicio en el siguiente paso
import { ToastService } from '../../Service/toast-service';

// Importaremos los modales de alta y edición en los siguientes pasos
import { SaasCompanyAdd } from '../saas-company-add/saas-company-add';
import { SaasCompanyEdit } from '../saas-company-edit/saas-company-edit';
import { Router } from '@angular/router';

@Component({
  selector: 'app-saas-cockpit-list',
  standalone: true,
  imports: [CommonModule, FormsModule, RouterLink],
  templateUrl: './saas-cockpit-list.html',
  //styleUrl: './saas-cockpit-list.css'
})
export class SaasCockpitList implements OnInit {
  companias: CompanyMaster[] = [];
  companiasFiltradas: CompanyMaster[] = [];
  filtroTexto: string = '';

  // 🧭 VARIABLES CORE PARA TU PAGINACIÓN CON SALTOS EXTREMOS
  paginaActual: number = 1;
  registrosPorPagina: number = 10;
  totalPaginas: number = 1;
  protected readonly Math = Math; // Puente legal exigido por Ivy ts(2339)

  constructor(
    private saasService: SaasService,
    public toastService: ToastService,
    private dialog: MatDialog,
    private router: Router,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.cargarInquilinosSaaS();
  }

  cargarInquilinosSaaS(): void {
    console.log('>>> [MÁSTER COCKPIT] Solicitando matriz global de compañías inquilinas...');
    this.saasService.getCompaniesGlobalList().subscribe({
      next: (data: CompanyMaster[]) => {
        this.companias = data;
        this.companiasFiltradas = [...data]; // Clonación inicial automática para que no nazca vacío el grid
        this.calcularTotalPaginas();
        this.cdr.markForCheck();
        this.cdr.detectChanges();
      },
      error: (err) => {
        console.error(err);
        this.toastService.showDanger('Fallo de Conexión', 'No se pudo recuperar la matriz de inquilinos del SaaS.');
      }
    });
  }

   /**
   * 🔍 MOTOR DE BÚSQUEDA ADAPTATIVO CON RE-PAGINACIÓN EN CALIENTE (PROTEGIDO)
   * Usa operadores de respaldo (|| '') para evitar que valores NULL o UNDEFINED de MySQL 
   * rompan el toUpperCase() y congelen la pantalla del Cockpit.
   */
  filtrarCompanias(): void {
    const busqueda = this.filtroTexto.trim().toUpperCase();
    
    if (!busqueda) {
      this.companiasFiltradas = [...this.companias];
    } else {
      this.companiasFiltradas = this.companias.filter(c => {
        // 🛡️ BLINDAJE ANTI-NULL: Si alguna columna viene vacía del ERP, se evalúa como texto vacío ''
        const id = (c.coId || '').toUpperCase();
        const razonSocial = (c.nameAlpha || '').toUpperCase();
        const rfc = (c.taxId || '').toUpperCase();
        const dueno = (c.ownerName || '').toUpperCase(); // 🎯 Rescatado de forma segura
        const unidadNegocio = (c.mcuBu || '').toUpperCase();

        return id.includes(busqueda) ||
               razonSocial.includes(busqueda) ||
               rfc.includes(busqueda) ||
               dueno.includes(busqueda) || // Evita el desplome por TypeError
               unidadNegocio.includes(busqueda);
      });
    }

    this.paginaActual = 1; // Reseteo automático a página 1 tras filtrar
    this.calcularTotalPaginas();
  }

  calcularTotalPaginas(): void {
    this.totalPaginas = Math.ceil(this.companiasFiltradas.length / this.registrosPorPagina) || 1;
    this.cdr.detectChanges();
  }

  /**
   * 💡 COMPUERTA RECTANGULAR: Recorta el array en memoria para entregarle al HTML
   * únicamente lo que se alcanza a ver en la pantalla de la tablet o monitor.
   */
  get companiasPaginadas(): CompanyMaster[] {
    const inicio = (this.paginaActual - 1) * this.registrosPorPagina;
    const fin = inicio + this.registrosPorPagina;
    return this.companiasFiltradas.slice(inicio, fin);
  }

  cambiarPagina(nuevaPagina: number): void {
    if (nuevaPagina >= 1 && nuevaPagina <= this.totalPaginas) {
      this.paginaActual = nuevaPagina;
      this.cdr.detectChanges();
    }
  }

/*   abrirAltaInquilino(): void {
    const dialogRef = this.dialog.open(SaasCompanyAdd, {
      width: '100vw',
      height: '100vh',
      maxWidth: '100vw',
      maxHeight: '100vh',
      disableClose: true,
      panelClass: 'saas-full-screen-modal' // Permite quitarle paddings nativos si fuera necesario
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.toastService.showSuccess(
          'Despliegue Exitoso', 
          `El taller [${result.nameAlpha}] ha sido provisionado de forma atómica en MySQL.`
        );
        this.cargarInquilinosSaaS(); // Recarga el grid en caliente mostrando la nueva fila
      }
    });
  } */

  abrirEdicionInquilino(empresa: CompanyMaster): void {
    console.log('📡 [MÁSTER COCKPIT] Descargando expediente extendido para:', empresa.nameAlpha);
    
    // Disparamos la lectura robusta antes de levantar la interfaz
    this.saasService.getCompanyDetails(empresa.coId).subscribe({
      next: (expedienteCompleto) => {
        // Le inyectamos el coId de forma explícita por seguridad
        expedienteCompleto.coId = empresa.coId;

        const dialogRef = this.dialog.open(SaasCompanyEdit, {
          width: '95%',
          maxWidth: '1100px',
          disableClose: true,
          data: expedienteCompleto // 🎯 Angular recibe ahora la radiografía relacional full
        });

        dialogRef.afterClosed().subscribe(result => {
          if (result) {
            this.toastService.showSuccess('Reestructuración Exitosa', `Los cambios para [${result.nameAlpha}] se han asentado en MySQL.`);
            this.cargarInquilinosSaaS();
          }
        });
      },
      error: (err) => {
        console.error('Error al obtener detalles de la empresa:', err);
        this.toastService.showDanger('Error de Sincronización', 'No se pudo recuperar el expediente legal del taller.');
      }
    });
  }

}